export default __webpack_public_path__ + "static/media/fe_ofish_logo.5e4de027.png";